import { useMutation, useQueryClient } from 'react-query';
import { Http } from '../../services/Http';
import { Timesheet, TimesheetRowSingleDay } from '../../types';
import { MUTATION_KEYS, QUERY_KEYS } from '../constants';

type Props = {
  payload: OverideTimesheetPayload;
  id: number;
};

type OverideTimesheetPayload = {
  dayName: string;
  day: number;
  data: TimesheetRowSingleDay[];
};

async function overideTimesheet({ payload, id }: Props): Promise<Timesheet> {
  const { data } = await Http.axios.patch<OverideTimesheetPayload, Timesheet>(
    `timesheet/overide/${id}`,
    payload
  );
  return data;
}

export const useOverideTimesheet = () => {
  const queryClient = useQueryClient();

  return useMutation(overideTimesheet, {
    mutationKey: MUTATION_KEYS.OVERIDE_TIMESHEET,
    onSuccess: (ts) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SINGLE_TIMESHEET, ts.id],
      });
    },
  });
};
